// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { jsx as _jsx } from "react/jsx-runtime";
import gemCategorySpatialIcon from '../../../assets/new_gems/Category/GemCategorySpatial.svg?inline';
import React from 'react';
export const GemCategorySpatial = (props)=>{
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: gemCategorySpatialIcon,
        alt: "GemCategorySpatialImage"
    });
};
